import type { ProviderSummary } from "./api.ts";
import { getState, isCategoryVisible } from "./store.ts";

/**
 * The catalogue minus everything the user switched off.
 *
 * Two independent switches narrow it: whole categories (Gay and Trans start
 * hidden) and individual providers. Every surface that lists providers goes
 * through here, so a hidden category cannot leak into a rail, a picker, a
 * search chip or the drawer.
 */
export function visibleProviders(providers: ProviderSummary[]): ProviderSummary[] {
  const disabled = new Set(getState().settings.disabledProviders);
  return providers.filter(
    (provider) => !disabled.has(provider.id) && isCategoryVisible(provider.category),
  );
}

/** Category ids present in a provider list, in catalogue order. */
export function categoriesOf(providers: ProviderSummary[]): string[] {
  return [...new Set(providers.map((provider) => provider.category))];
}
